import Vue from 'vue';
import Vuex from 'vuex';
import localdata from './services/localdata.service';

Vue.use(Vuex);

const dummyClient = {
    id: -1,
    name: '',
    currency: '',
    settings: {
        pinExpirationPeriod: 0
    }
};

const handlers = {
    adminTimezone: {
        set: 'adminTimezone_set'
    },
    admin: {
        set: 'admin_set'
    },
    clients: {
        set: 'clients_set'
    },
    currencies: {
        set: 'currencies_set'
    },
    breadcrumbs: {
        setBreadcrumb: 'breadcrumbs_set_breadcrumb'
    },
    editPlayer: {
        set: 'editPlayer_set'
    },
    editAgent: {
        set: 'editAgent_set'
    },
    timezones: {
        set: 'timezones_set'
    },
    languages: {
    }
};

const store = new Vuex.Store({
    state: {
        adminTimezone: localdata.getTimezone() || { id: 'UTC', name: 'UTC', description: 'UTC (+00:00)', offset: 0 },
        admin: null,
        clients: [],
        currencies: [],
        dynamicBreadcrumbs: [],
        editPlayer: null,
        editAgent: null,
        timezones: [],
        languages: ['ru', 'en', 'fr', 'es', 'zh_CN', 'he', 'ar', 'uz']
    },
    getters: {
        adminTimezone: state => state.adminTimezone,
        admin: state => state.admin,
        clients: state => state.clients,
        currencies: state => state.currencies,
        dynamicBreadcrumbs: state => state.dynamicBreadcrumbs,
        editPlayer: state => state.editPlayer,
        editAgent: state => state.editAgent,
        timezones: state => state.timezones,
        languages: state => state.languages
    },
    actions: {
        [handlers.adminTimezone.set]: ({ commit }, adminTimezone) => commit(handlers.adminTimezone.set, adminTimezone),
        [handlers.admin.set]: ({ commit }, admin) => commit(handlers.admin.set, admin),
        [handlers.clients.set]: ({ commit }, clients) => commit(handlers.clients.set, clients),
        [handlers.currencies.set]: ({ commit }, currencies) => commit(handlers.currencies.set, currencies),
        [handlers.breadcrumbs.setBreadcrumb]: ({ commit }, breadcrumb) => commit(handlers.breadcrumbs.setBreadcrumb, breadcrumb),
        [handlers.editPlayer.set]: ({ commit }, player) => commit(handlers.editPlayer.set, player),
        [handlers.editAgent.set]: ({ commit }, player) => commit(handlers.editAgent.set, player),
        [handlers.timezones.set]: ({ commit }, timezones) => commit(handlers.timezones.set, timezones)
    },
    mutations: {
        [handlers.adminTimezone.set]: (state, adminTimezone) => (state.adminTimezone = adminTimezone),
        [handlers.admin.set]: (state, admin) => (state.admin = admin),
        [handlers.clients.set]: (state, clients) => (state.clients = clients),
        [handlers.currencies.set]: (state, currencies) => (state.currencies = currencies),
        [handlers.breadcrumbs.setBreadcrumb]: (state, breadcrumb) => {
            let isNew = true;
            state.dynamicBreadcrumbs.forEach(b => {
                if (b.key === breadcrumb.key) {
                    b.func = breadcrumb.func;
                    isNew = false;
                }
            });
            if (isNew) {
                state.dynamicBreadcrumbs.push(breadcrumb);
            }
        },
        [handlers.editPlayer.set]: (state, player) => (state.editPlayer = player),
        [handlers.editAgent.set]: (state, agent) => (state.editAgent = agent),
        [handlers.timezones.set]: (state, timezones) => (state.timezones = timezones)
    }
});

export default {
    store,
    adminTimezone: {
        get: () => store.getters.adminTimezone,
        set: adminTimezone => {
            store.dispatch(handlers.adminTimezone.set, adminTimezone);
            localdata.storeTimezone(adminTimezone);
        }
    },
    admin: {
        get: () => store.getters.admin,
        set: admin => store.dispatch(handlers.admin.set, admin),
        unset: () => store.dispatch(handlers.admin.set, null)
    },
    clients: {
        get: () => store.getters.clients,
        getClient: clientId => store.getters.clients.filter(c => c.id === clientId)[0] || dummyClient,
        set: clients => store.dispatch(handlers.clients.set, clients)
    },
    currencies: {
        get: () => store.getters.currencies,
        getCurrency: currencyId => store.getters.currencies.find(c => c.id === currencyId),
        set: currencies => store.dispatch(handlers.currencies.set, currencies)
    },
    dynamicBreadcrumbs: {
        get: () => store.getters.dynamicBreadcrumbs,
        setBreadcrumb: breadcrumb => store.dispatch(handlers.breadcrumbs.setBreadcrumb, breadcrumb)
    },
    editPlayer: {
        get: () => store.getters.editPlayer,
        set: player => store.dispatch(handlers.editPlayer.set, player),
        unset: () => store.dispatch(handlers.editPlayer.set, null)
    },
    editAgent: {
        get: () => store.getters.editAgent,
        set: agent => store.dispatch(handlers.editAgent.set, agent),
        unset: () => store.dispatch(handlers.editAgent.set, null)
    },
    timezones: {
        get: () => store.getters.timezones,
        getTimezone: timezoneId => store.getters.timezones.filter(tz => tz.id === timezoneId)[0] || { id: 'UTC', offset: 0 },
        set: timezones => store.dispatch(handlers.timezones.set, timezones)
    },
    languages: {
        get: () => store.getters.languages
    }
};



// WEBPACK FOOTER //
// ./src/state.js